import { render, staticRenderFns } from "./fixed-header.vue?vue&type=template&id=61e3ab54&"
import script from "./fixed-header.vue?vue&type=script&lang=js&"
export * from "./fixed-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports